// import script accordingly
// import "./themes/header/_header";
import "./themes/header/_header";
import './themes/loop/_loop.js';
import './themes/slider/_slider.js';
